import ForestSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Forest.png"
import FireSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Fire.png"
import WaterSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Water.png"
import ShadowSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Shadow.png"
import SpiritSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Spirit.png"
import BotWSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Botw.png"
import GTGSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_GTG.png"
import FotressSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Fortress.png"
import GanonSmallKey from "../../core/assets/oot/classic/OoT_Small_Key_Model_Ganon.png"
import ForestBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Forest.png"
import FireBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Fire.png"
import WaterBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Water.png"
import ShadowBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Shadow.png"
import SpiritBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Spirit.png"
import GanonBKey from "../../core/assets/oot/classic/OoT_Boss_Key_Model_Ganon.png"


export interface DungeonsKeys {
    nbKeysVanilla: number,
    nbKeysMq: number,
    smallKeyImg: string,
    bkImg: string,
    dungeon: string
}

export const DungeonsKeysList: Array<DungeonsKeys> = [
    {dungeon: "Deku" , nbKeysVanilla: 0, nbKeysMq: 0, smallKeyImg: "", bkImg: ""  },
    {dungeon: "DC" , nbKeysVanilla: 0, nbKeysMq: 0, smallKeyImg: "", bkImg: ""  },
    {dungeon: "Jabu" , nbKeysVanilla: 0, nbKeysMq: 0, smallKeyImg: "", bkImg: ""  },
    {dungeon: "Forest" , nbKeysVanilla: 5, nbKeysMq: 6, smallKeyImg: ForestSmallKey, bkImg: ForestBKey  },
    {dungeon: "Fire" , nbKeysVanilla: 8, nbKeysMq: 5, smallKeyImg: FireSmallKey, bkImg: FireBKey  },
    {dungeon: "Water" , nbKeysVanilla: 6, nbKeysMq: 2, smallKeyImg: WaterSmallKey, bkImg: WaterBKey  },
    {dungeon: "Shadow" , nbKeysVanilla: 5, nbKeysMq: 6, smallKeyImg: ShadowSmallKey, bkImg: ShadowBKey  },
    {dungeon: "Spirit" , nbKeysVanilla: 5, nbKeysMq: 7, smallKeyImg: SpiritSmallKey, bkImg: SpiritBKey  },
    {dungeon: "BotW" , nbKeysVanilla: 3, nbKeysMq: 2, smallKeyImg: BotWSmallKey, bkImg: ""  },
    {dungeon: "GTG" , nbKeysVanilla: 9, nbKeysMq: 3, smallKeyImg: GTGSmallKey, bkImg: ""  },
    {dungeon: "Ice" , nbKeysVanilla: 0, nbKeysMq: 0, smallKeyImg: "", bkImg: ""  },
    {dungeon: "Fortress" , nbKeysVanilla: 4, nbKeysMq: 4, smallKeyImg: FotressSmallKey, bkImg: ""  },
    {dungeon: "Ganon" , nbKeysVanilla: 2, nbKeysMq: 3, smallKeyImg: GanonSmallKey, bkImg: GanonBKey  }
]